// src/pages/demo/DemoContentLibraryHomework.js
//
// Content Library preview page — opens the pre-generated lesson from the pipeline
// in supply-teacher mode, showing all components fully populated.
// Architecturally separate from DemoHomeworkDetail (different utility: preview,
// not class management).
//
import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { contentLibraryAPI } from '../../services/api';
import DemoHomeworkDetail from './DemoHomeworkDetail';

const DemoContentLibraryHomework = ({ user, onLogout }) => {
    const { id } = useParams();
    const location = useLocation();
    const jcqState = location.state || {};
    const [homeworkId, setHomeworkId] = useState(null);
    const [lessonTitle, setLessonTitle] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        contentLibraryAPI.open(id)
            .then(res => {
                setHomeworkId(res.data.homeworkId);
                setLessonTitle(res.data.lessonTitle || '');
            })
            .catch(() => setError('Failed to load lesson preview. Please try again.'));
    }, [id, user?.uid]);

    if (error) {
        return (
            <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Inter, sans-serif', color: '#E07A5F' }}>
                {error}
            </div>
        );
    }

    if (!homeworkId) {
        return (
            <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Inter, sans-serif', color: '#5D7375' }}>
                Loading lesson...
            </div>
        );
    }

    return (
        <DemoHomeworkDetail
            user={user}
            onLogout={onLogout}
            homeworkId={homeworkId}
            libraryPreview={true}
            libraryEntryId={id}
            libraryLessonTitle={lessonTitle}
            jcqMode={Boolean(jcqState.jcqMode)}
            jcqBucketId={jcqState.jcqBucketId || ''}
            jcqReturnPath={jcqState.jcqReturnPath || ''}
            jcqLessonMeta={jcqState.jcqLessonMeta || {}}
        />
    );
};

export default DemoContentLibraryHomework;
